import app from '../app.first';
import $ from 'jquery';

app.Register = class extends app.Component {
    constructor($this) {
        super($this);
        $(() => this.onDocumentReady($this));
        this.$id = $('#pd_id_number');
        this.$idError = $('#pd_id_number_error');
        this.$fileUploads = $('[type="file"]');
    }

    onDocumentReady($this) {
        $('#pd_country_id').select2({
            width: '100%'  // Ensure select2 takes full width
        }).on("change", function(e) {
            const selectedCountryId = $(this).val();
            const southAfricaCountryId = '246';

            if (selectedCountryId == southAfricaCountryId) {
                $('#pd_id_number_wrapper_for_id_validation').removeClass('hide');
                $('#pd_passport_number_wrapper_for_id_validation').addClass('hide');

                $('#pd_passport_number_for_id_validation').prop('disabled', true);
                $('#pd_passport_number_for_id_validation').prop('required', false);

                $('#pd_id_number').prop('disabled', false);
                $('#pd_id_number').prop('required', true);
                $('#pd_id_number').attr('data-mustvalidated', 'true');
                $('#rc_mobile_primary').attr('data-mustvalidated', 'true');

            } else {
                $('#pd_id_number_wrapper_for_id_validation').addClass('hide');
                $('#pd_passport_number_wrapper_for_id_validation').removeClass('hide');

                $('#pd_passport_number_for_id_validation').prop('disabled', false);
                $('#pd_passport_number_for_id_validation').prop('required', true);

                $('#pd_id_number').removeProp('required');
                $('#pd_id_number').attr('data-mustvalidated', 'false');
                $('#rc_mobile_primary').attr('data-mustvalidated', 'false');
            }
        }).trigger('change');

        this.$fileUploads.on('change', function() {
            let $this = $(this);
            $this.closest('.file').find('.file-name').html($this.val().split('\\').pop());
        });

        // if #pd_id_number_error is not empty, then show #pd_passport_number_wrapper_for_id_validation
        if ($('.error-message').length > 0) {
            $('#pd_passport_number_wrapper_for_id_validation').removeClass('hide');
            $('#pd_passport_number_for_id_validation').prop('disabled', false);
            $('#pd_passport_number_for_id_validation').prop('required', true);
        }
    }
}
